export const AFFECTED_SERVICES_SCHEMA_CUSTOM =
	'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
export const CMDB_SCHEMA_CUSTOM = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
export const LABELS_SCHEMA_CUSTOM = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
export const LABELS_SCHEMA_SYSTEM = 'labels';
